import React from 'react'

import PMList from 'components/preventative-maintenance/list'

const PreventativeMaintenance = () => {
  return <PMList />
}

export default PreventativeMaintenance
